export default __webpack_public_path__ + "static/media/navigation.cca74070.jpg";